import { render, staticRenderFns } from "./orders_form.vue?vue&type=template&id=22d550c8&scoped=true&"
import script from "./orders_form.vue?vue&type=script&lang=js&"
export * from "./orders_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d550c8",
  null
  
)

export default component.exports